import React from "react";
const AboutUs = () => {
  return (
    <section id="about" className="section">
      <div className="container">
        {/* Heading */}
        <p className="text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">About Me</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          Know Me More
        </h2>
        {/* Heading end*/}
        <div className="row">
          <div className="col-lg-8 text-center text-lg-start wow fadeInUp">
            <h2 className="text-8 fw-400 mb-3">
              Hi, I'm{" "}
              <span className="fw-700 border-bottom border-3 border-primary">
                DANE BARATA
              </span>
            </h2>
            {/* <p className="text-5">
             I'm a seasoned finance executive, operator, entrepreneur, and investor working 
             at the intersection of capital, operations, and scalable growth. For over 25 years, 
             I've held leadership roles across startups, family businesses, mid-sized companies, 
             Fortune 500 companies, and nonprofit organizations — guiding transformations, 
             acquisitions, turnarounds, and value creation. I'm drawn to the messy, honest work 
             of scaling — building infrastructure, systems, and teams that can not only survive 
             but thrive under complexity. I believe the best returns come from businesses that 
             are purpose-driven, operationally excellent, and aligned with long-term value creation.

            </p> */}
            {/* <p className="text-5">
              Seasoned finance executive, operator, and investor with 25+ years
              at the intersection of capital, operations, and scalable growth —
              guiding transformations, acquisitions, and turnarounds across
              startups, Fortune 500s, and nonprofits. I build infrastructure,
              systems, and teams that thrive under complexity, driven by the
              belief that the best returns come from businesses that are
              purpose-driven and aligned with long-term value creation.
            </p> */}

            <p className="text-5">
              I'm a seasoned finance executive, operator, entrepreneur, and
              investor working at the intersection of capital, operations, and
              scalable growth. For over 25 years, I've held leadership roles in
              startups, family businesses, mid-sized companies, Fortune 500
              companies, and nonprofit organizations, guiding transformations,
              acquisitions, turnarounds, and value creation.
            </p>
          </div>
          <div
            className="col-lg-4 mt-4 mt-lg-0 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <div className="featured-box style-4">
              <div className="featured-box-icon text-25 fw-500 bg-primary rounded-circle">
                <span className="wow heartBeat" data-wow-delay="1.3s">
                  25
                </span>
              </div>
              <h3 className="text-7 wow rubberBand" data-wow-delay="2s">
                Years of <span className="fw-700">Experiance</span>
              </h3>
            </div>
          </div>
        </div>
        <div className="row gy-3 mt-4">
          <div className="col-6 col-lg-3 wow fadeInUp">
            <p className="text-muted fw-500 mb-0">Name:</p>
            <p className="text-4 text-dark fw-600 mb-0">Dane Barata</p>
          </div>
          <div className="col-6 col-lg-3 wow fadeInUp" data-wow-delay="0.2s">
            <p className="text-muted fw-500 mb-0">Email:</p>
            <p className="text-4 fw-600 mb-0">
              <a className="link-dark" href="mailto:dane@psenvironmental.com">
                dane@psenvironmental.com
              </a>
            </p>
          </div>
          {/* <div className="col-6 col-lg-3 wow fadeInUp" data-wow-delay="0.3s">
            <p className="text-muted fw-500 mb-0">Date of birth:</p>
            <p className="text-4 text-dark fw-600 mb-0">11 November, 1987</p>
          </div> */}
          <div className="col-6 col-lg-3 wow fadeInUp" data-wow-delay="0.4s">
            <p className="text-muted fw-500 mb-0">From:</p>
            <p className="text-4 text-dark fw-600 mb-0">
              Rancho Palos Verdes, CA
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
